import { ControlledFormInput } from '@components/formInputs/ControlledFormInput';
import { LayoutVariant } from '@components/formInputs/sharedTypes';
import { formatPhone } from '@utils/formatPhone';
import { useFormContext, useWatch } from 'react-hook-form';
import { SettingsOutletHeader } from '../../shared/SettingsOutletHeader';
import { type AdminRestaurant } from '../../team/apiHelpers';
import { type GeneralSettingsForm } from '../utils/generalSettingsFormTypes';
import { maxGuestCountTip } from '../utils/maxGuestCountTip';
import layoutStyles from './MaxGuestCountSection.scss';

export interface MaxGuestCountSectionProps {
  restaurant: AdminRestaurant;
  sectionTitleId: string;
}

export const MaxGuestCountSection = ({
  restaurant,
  sectionTitleId,
}: MaxGuestCountSectionProps) => {
  const { control } = useFormContext<GeneralSettingsForm>();
  const watchedMaxGuestCount = useWatch({ control, name: 'maxGuestCount' });

  return (
    <section className={layoutStyles.section} aria-labelledby={sectionTitleId}>
      <SettingsOutletHeader
        variant="section"
        titleId={sectionTitleId}
        title="Max Guest Count"
        subtitle={maxGuestCountTip(
          watchedMaxGuestCount ?? restaurant.maxReservationGuests,
          formatPhone(restaurant.phone),
        )}
      />
      <div className={layoutStyles.formFields}>
        <ControlledFormInput
          control={control}
          label="Maximum Guest Count"
          name="maxGuestCount"
          rules={{
            max: {
              message: 'Must not exceed 1,000',
              value: 1000,
            },
            min: {
              message: 'Must be at least 1',
              value: 1,
            },
            required: true,
          }}
          type="number"
          variant={LayoutVariant.Vertical}
          className={layoutStyles.constrainedField}
        />
      </div>
    </section>
  );
};
